import {
  FeatureName,
  useCurrentAccount,
  useCurrentWorkspace,
  useIsFeatureEnabledForWorkspace,
} from '@gripp/shared-logic';

export const INTEGRATION_SETTINGS_PERMISSION = 'workspaceintegration.update';

export const useIntegrationSettingsAccess = () => {
  const workspace = useCurrentWorkspace();
  const { account, isLoading, isFetching } = useCurrentAccount();
  const feature = useIsFeatureEnabledForWorkspace(
    FeatureName.IntegrationConnections,
    workspace?.id
  );
  const loading = isLoading || isFetching || feature.isLoading;
  // Account permissions belong to its selected workspace. Only an operator
  // can use the separate stored workspace used by workspace impersonation.
  const workspaceMatches =
    workspace?.id === account?.workspace?.id || account?.isGlobalAdmin();

  return {
    workspaceId: workspace?.id,
    accountId: account?.id,
    isLoading: loading,
    canManage: !!(
      !loading &&
      workspace?.id &&
      workspaceMatches &&
      feature.isEnabled &&
      account?.hasPermission(INTEGRATION_SETTINGS_PERMISSION)
    ),
  };
};
